<div *ngIf="isShow" class="bubble">
  <button class="close-btn" id="modal-close-btn" (click)="isShow = false">
    <!-- <i class="fas fa-times"></i> -->X
  </button>

  <p class="header" style="font-weight: bold">{{ header }}</p>

  <ng-content></ng-content>
</div>
